import Cookies from 'universal-cookie'
import { aiproFlags } from '../../hooks/flags'
const cookies = new Cookies()

export function SetCookie(name, value, option = { path: '/' }) {
    option['domain'] = '.ai-pro.org'

    cookies.set(name, value, option)
    aiproFlags.flags[name] = value
};

export function RemoveCookie(name, option = { path: '/' }) {
    option['domain'] = '.ai-pro.org'

    cookies.remove(name, option)
    aiproFlags.flags[name] = ""
};

export function GetCookie(name) {
    return cookies.get(name) || aiproFlags.flags[name] || ""
};

export function GetSubdomain() {
    const fullHostName = window.location.hostname
    const checkDomain = fullHostName.includes("chatapp") || fullHostName.includes("chat-app")
    return checkDomain
}
